/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const updateTicketTitleRequestSchema = z.object({
  title: z.string().min(1).max(200),
});

export type IUpdateTicketTitleRequest = z.infer<typeof updateTicketTitleRequestSchema>;
